import { Col, Divider, Form, Input, InputNumber, Layout, Row, Select, Space } from "antd";
import styles from "./sell.module.less";
import i18n, { languageKeys } from "../../../../i18n";
import { calcTotal, formatNumberToPrice } from "helpers";
import { Trash } from "assets/svg";
import { PlusCircleFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { doFetchPaymentMethod, getSharedData } from "ducks/slices/ListData/SharedData.slice";

const SiderPayment = ({ form, supplyList = [], isAdvance, setIsAdvance }) => {

  const dispatch = useDispatch();
  const { paymentMethod } = useSelector(getSharedData);
  const advanceMoney = { TOTAL_TAM_UNG: 0 }

  const paymentList = Form.useWatch("LIST_HINH_THUC_THANH_TOAN", form)
  const MIEN_GIAM = Form.useWatch("MIEN_GIAM", form)
  const TIEN_KHACH_DUA = Form.useWatch("TIEN_KHACH_DUA", form)


  const TONG_CHI_PHI = supplyList
    .filter(i => i.SO_LUONG)
    .reduce((tol, obj) => tol + (obj.SO_LUONG * obj.GIA_BAN), 0)
  //
  const TONG_MIEN_GIAM = calcTotal(supplyList, "TONG_MIEN_GIAM") + (
    MIEN_GIAM
      ? MIEN_GIAM > 100
        ? MIEN_GIAM
        : calcTotal(supplyList, "THANH_TIEN") / 100 * MIEN_GIAM
      : 0
  )
  const TONG_THANH_TOAN = calcTotal(supplyList, "THANH_TIEN") - (
    MIEN_GIAM
      ? MIEN_GIAM > 100
        ? MIEN_GIAM
        : calcTotal(supplyList, "THANH_TIEN") / 100 * MIEN_GIAM
      : 0
  )
  const BENH_NHAN_DUA = calcTotal(paymentList, "BENH_NHAN_DUA") + (isAdvance ? advanceMoney.TOTAL_TAM_UNG : 0)
  //
  const ID_TIEN_MAT = paymentMethod.find((i) => i.PHAN_LOAI_HINH_THUC === "TIEN_MAT")?.ID


  // Khởi tạo HTTT và sổ hóa đơn
  useEffect(() => {
    // !invoiceBook[0] && dispatch(doFetchBook({ LOAI_SO: 'SO_THU_TIEN' }))
    !paymentMethod[0] && dispatch(doFetchPaymentMethod())
  }, []);

  useEffect(() => {
    paymentMethod[0] && form.setFieldValue(["LIST_HINH_THUC_THANH_TOAN", 0, "HINH_THUC_THANH_TOAN_ID"], ID_TIEN_MAT)
  }, [paymentMethod])

  // useEffect(() => {
  //   invoiceBook[0] && form.setFieldValue("SO_HOADON_ID", invoiceBook[0].ID)
  // }, [invoiceBook])


  // Thay đổi miễn giảm
  const handleChangeExemption = (value) => {
    form.setFields([
      {
        name: "LIST_HINH_THUC_THANH_TOAN",
        value: [{
          HINH_THUC_THANH_TOAN_ID: ID_TIEN_MAT,
          BENH_NHAN_DUA: calcTotal(supplyList, "THANH_TIEN") - (
            value
              ? value > 100
                ? value
                : calcTotal(supplyList, "THANH_TIEN") / 100 * value
              : 0
          )
        }]
      },
      {
        name: "TIEN_KHACH_DUA",
        value: calcTotal(supplyList, "THANH_TIEN") - (
          value
            ? value > 100
              ? value
              : calcTotal(supplyList, "THANH_TIEN") / 100 * value
            : 0
        )
      },
    ])
  }

  // Trường hợp chọn tiền mặt
  const handleSelectMethod = (record, index) => {
    if (record.PHAN_LOAI_HINH_THUC === "TIEN_MAT") {
      form.setFieldValue("TIEN_KHACH_DUA", paymentList[index].BENH_NHAN_DUA)
    }
  }

  // Check khách đưa thừa
  const checkOverLimit = () => {
    // if (isAdvance && advanceMoney.TOTAL_TAM_UNG > TONG_THANH_TOAN) return Promise.resolve();
    if (BENH_NHAN_DUA > TONG_THANH_TOAN) return Promise.reject("");
    return Promise.resolve();
  };

  // Xử lý chọn tạm ứng
  // const handleCheckAdvance = (checked: boolean) => {
  //   setIsAdvance(checked)
  //   form.setFields([
  //     {
  //       name: "LIST_HINH_THUC_THANH_TOAN",
  //       value: [{
  //         HINH_THUC_THANH_TOAN_ID: ID_TIEN_MAT,
  //         BENH_NHAN_DUA: checked
  //           ? (advanceMoney.TOTAL_TAM_UNG > TONG_THANH_TOAN ? undefined : (TONG_THANH_TOAN - advanceMoney.TOTAL_TAM_UNG))
  //           : TONG_THANH_TOAN
  //       }]
  //     },
  //     {
  //       name: "TIEN_KHACH_DUA",
  //       value: checked
  //         ? (advanceMoney.TOTAL_TAM_UNG > TONG_THANH_TOAN ? 0 : (TONG_THANH_TOAN - advanceMoney.TOTAL_TAM_UNG))
  //         : TONG_THANH_TOAN
  //     },
  //   ])
  // }

  // HTML
  return (
    <Layout.Sider
      width={220}
      theme="light"
      className={styles['right_sider']}
    >
      <h4>{i18n.t(languageKeys.field_Thanh_toan)}</h4>
      <Divider />
      <Form form={form} layout="vertical">

        <Space direction="vertical" className={styles['money_container']} style={{ marginBottom: 5 }}>
          <Space>
            <span>{i18n.t(languageKeys.tong_tien)}:</span>
            <b>{formatNumberToPrice(TONG_CHI_PHI, ' đ')}</b>
          </Space>

          <Space>
            <span>{i18n.t(languageKeys.field_Mien_giam)}:</span>
            <Form.Item name={"MIEN_GIAM"} className={styles.exemption}>
              <InputNumber
                placeholder={i18n.t(languageKeys.common_Nhap)}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                controls={false}
                max={TONG_CHI_PHI - calcTotal(supplyList, "GIAM_TIEN")}
                min={0}
                onChange={handleChangeExemption}
                addonAfter={MIEN_GIAM > 100 ? "đ" : "%"}
              />
            </Form.Item>
          </Space>

          <Space>
            <span>{i18n.t(languageKeys.vienphi_tong_mien_giam)}:</span>
            <b>{formatNumberToPrice(TONG_MIEN_GIAM, ' đ')}</b>
          </Space>

          <Space>
            <span>{i18n.t(languageKeys.field_Tong_thanh_toan)}:</span>
            <b style={{ color: '#2CB2A5' }}>{formatNumberToPrice(Math.round(TONG_THANH_TOAN), ' đ')}</b>
          </Space>
        </Space>

        <Divider dashed />

        <Form.Item label={i18n.t(languageKeys.field_Ly_do_mien_giam)} name={"LY_DO_MIEN_GIAM"}>
          <Input placeholder={i18n.t(languageKeys.common_Nhap)} />
        </Form.Item>

        <Divider dashed />

        {/* {advanceMoney.TOTAL_TAM_UNG > 0 && (
          <Space direction="vertical" className={styles['money_container']}>
            <Checkbox
              checked={isAdvance || advanceMode}
              onChange={(e) => !advanceMode && handleCheckAdvance(e.target.checked)}
            >
              Sử dụng tiền tạm ứng
            </Checkbox>
            <Space>
              <span>Tổng tạm ứng:</span>
              <b style={{ color: '#2CB2A5' }}>
                {formatNumberToPrice(advanceMoney.TOTAL_TAM_UNG, " đ")}
              </b>
            </Space>
          </Space>
        )} */}

        <Form.List name="LIST_HINH_THUC_THANH_TOAN">
          {(fields, { add, remove }) => (
            <Col span={24}>
              {fields.map(({ key, name, ...restField }) => (
                <Row className={styles["payment-container"]} key={key}>
                  {fields.length > 1 && (
                    <div className={styles["delete-btn"]} onClick={() => remove(name)}>
                      <Trash />
                    </div>
                  )}
                  <Col span={24}>
                    <Form.Item
                      {...restField}
                      name={[name, "HINH_THUC_THANH_TOAN_ID"]}
                      label={i18n.t(languageKeys.field_hinh_thuc_thanh_toan)}
                      rules={[{
                        required: !(isAdvance && advanceMoney.TOTAL_TAM_UNG),
                        message: i18n.t(languageKeys.please_chon)
                      }]}
                    >
                      <Select
                        placeholder={i18n.t(languageKeys.common_Chon)}
                        options={paymentMethod
                          .filter((i) => i.PHAN_LOAI_HINH_THUC !== "TAM_UNG" && i.PHAN_LOAI_HINH_THUC !== "CONG_NO")
                          .filter((item) => !paymentList?.some((i) => i.HINH_THUC_THANH_TOAN_ID === item.ID) || item.ID === paymentList[name].HINH_THUC_THANH_TOAN_ID)}
                        fieldNames={{
                          value: "ID",
                          label: "TEN_HINH_THUC_THANH_TOAN"
                        }}
                        onChange={(_, opt) => handleSelectMethod(opt, name)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      {...restField}
                      name={[name, "BENH_NHAN_DUA"]}
                      label={i18n.t(languageKeys.so_tien_thanh_toan)}
                      rules={[
                        {
                          required: !(isAdvance && advanceMoney.TOTAL_TAM_UNG),
                          message: i18n.t(languageKeys.vui_long_nhap),
                        },
                        { validator: checkOverLimit }
                      ]}
                    >
                      <InputNumber
                        placeholder={i18n.t(languageKeys.common_Nhap)}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        controls={false}
                        min={0}
                        onChange={(val) => {
                          if (paymentMethod.find((i) => i.ID === paymentList[name]?.HINH_THUC_THANH_TOAN_ID)?.PHAN_LOAI_HINH_THUC === "TIEN_MAT")
                            form.setFieldValue("TIEN_KHACH_DUA", val)
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              {TONG_THANH_TOAN > BENH_NHAN_DUA && (
                <Row
                  className={styles["btn-add"]}
                  onClick={() => add({ BENH_NHAN_DUA: TONG_THANH_TOAN - BENH_NHAN_DUA })}
                >
                  <PlusCircleFilled className="blue-txt" style={{ fontSize: 16, marginRight: 7 }} />
                  <p className="blue-txt">{i18n.t(languageKeys.them_httt)}</p>
                </Row>
              )}
            </Col>
          )}
        </Form.List>

        {/* <Form.Item
          label={i18n.t(languageKeys.vien_phi_so_hoa_don)}
          name={"SO_HOADON_ID"}
          initialValue={invoiceBook[0]?.ID}
          rules={[{ required: true, message: "" }]}
        >
          <Select
            placeholder={i18n.t(languageKeys.common_Chon)}
            options={invoiceBook}
            fieldNames={{
              value: "ID",
              label: "TEN_SO"
            }}
          />
        </Form.Item> */}

        {paymentList?.find((i) => i.HINH_THUC_THANH_TOAN_ID === ID_TIEN_MAT) && (
          <>
            <Form.Item label={i18n.t(languageKeys.tien_khach_dua)} name={"TIEN_KHACH_DUA"}>
              <InputNumber
                placeholder={i18n.t(languageKeys.common_Nhap)}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                controls={false}
                min={0}
              />
            </Form.Item>

            <Space direction="vertical" className={styles['money_container']} style={{ marginBottom: 5 }}>
              <Space>
                <span>{i18n.t(languageKeys.vien_phi_tien_thua)}:</span>
                <b>{formatNumberToPrice(Math.max(0, TIEN_KHACH_DUA + (isAdvance ? advanceMoney.TOTAL_TAM_UNG : 0) - TONG_THANH_TOAN), ' đ')}</b>
              </Space>
            </Space>
          </>
        )}

        <Form.Item label={i18n.t(languageKeys.ghi_chu)} name={"GHI_CHU"}>
          <Input.TextArea
            placeholder={i18n.t(languageKeys.common_Nhap)}
          />
        </Form.Item>

      </Form>
    </Layout.Sider>
  )
}

export default SiderPayment;